import { useState } from "react";
import Image from "next/image";
import { shimmer, toBase64 } from "@/components/core/PlaceholderImages/PlaceholderImages";

interface ImageWithFallbackProps {
  className?: string;
  alt: string;
  priority?: boolean;
  src: string;
  width: number;
  height: number;
  layout: "fill" | "fixed" | "intrinsic" | "responsive";
  sizes?: string;
  placeholder?: "blur" | "empty" | "dominantColor" | "none";
}

export default function ImageWithFallback({ className, alt, priority, src, width, height, layout, sizes, placeholder }) {
  const [source, setSource] = useState(src);

  return (
    <>
      <Image
        unoptimized
        className={className}
        alt={alt}
        blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(width, height))}`}
        width={width}
        height={height}
        layout={layout}
        src={source}
        sizes={sizes}
        placeholder={placeholder}
        priority={priority}
        onError={() => setSource("/static/images/product-img-placeholder.svg")}
      />
    </>
  );
}
